"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var react_1 = __importDefault(require("react"));
var AccordionSummary_1 = __importDefault(require("atomicComponents/atoms/Accordion/AccordionSummary"));
var Accordion_1 = __importDefault(require("shared/components/Accordion"));
var AccordionDetails_1 = __importDefault(require("shared/components/Accordion/AccordionDetails"));
var Text_1 = __importDefault(require("shared/components/Text"));
var AccordionInstructions = function (_a) {
    var icon = _a.icon, iconSize = _a.iconSize, title = _a.title, children = _a.children, _b = _a.selectTitle, selectTitle = _b === void 0 ? true : _b, rest = __rest(_a, ["icon", "iconSize", "title", "children", "selectTitle"]);
    var _c = __read(react_1.default.useState(false), 2), expanded = _c[0], setExpanded = _c[1];
    var handleOnHighlight = function (e) {
        e.preventDefault();
        var selectionObj = (window.getSelection && window.getSelection());
        var selection = selectionObj === null || selectionObj === void 0 ? void 0 : selectionObj.toString();
        setExpanded(function (prevExpanded) { return selection ? prevExpanded : !prevExpanded; });
    };
    var accordionProps = selectTitle ? { expanded: expanded, onChange: handleOnHighlight } : undefined;
    return ((0, jsx_runtime_1.jsxs)(Accordion_1.default, __assign({ hideBorders: true }, accordionProps, rest, { children: [(0, jsx_runtime_1.jsx)(AccordionSummary_1.default, __assign({ selectTitle: selectTitle }, { children: (0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "row", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon, color: "#70777C", size: iconSize }), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, pl: 3 }, { children: title }))] })) })), (0, jsx_runtime_1.jsx)(AccordionDetails_1.default, __assign({ sx: { pl: 7 } }, { children: children }))] })));
};
exports.default = AccordionInstructions;
